<template>
  <div>
    <div class="relative">
      <div class="absolute top-0 left-0 w-full h-full overflow-hidden" style="z-index: -9" :class="$route.name === 'invoicePDF' ? 'hidden' : 'block'">
        <img src="../../assets/images/body-Bg.png" alt="Body Bg" class="w-full h-screen object-cover mobile:hidden tablet:block">
        <img src="../../assets/images/mobile-bg.svg" alt="Body Bg" class="w-full object-cover mobile:block tablet:hidden">
      </div>
      <FLoader />
      <div
class="mobile:px-3 mobile:pt-28 laptop:pt-24 desktop:pt-16 largeDesktop:pt-20 largeDesktop:pl-10 pr-3 pb-4"
        :class="{ '!pt-[50px]' : isFromMobile == 1,
          'min-h-screen !px-0 !pt-0 inset-0': $route.name === 'commonParts',
    }"
>
        <router-view />
      </div>
    </div>
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>

<script>
export default {
  name: "Layout",

  components: {

  },

  data() {
    return {

    };
  },

  computed: {
    isFromMobile() {
      return this.$route.query.is_from_mobile ?? 0;
    },

  },
  mounted() { },

  methods: {

  }
};
</script>
